import { SxProps, Theme } from '@mui/material';

import { Folders } from '../../../@types/uploaded-files.type';

/** The look of an upload action, shared with the Images panel so they match. */
export const uploadActionSx: SxProps<Theme> = {
  fontSize: '11px',
  textTransform: 'none' as const,
  py: 0.75,
  px: 2.5,
  bgcolor: 'v4.accent',
  '&:hover': { bgcolor: 'v4.accent', opacity: 0.9 },
};

/**
 * The featureType each folder's uploads are filed under.
 *
 * Service attachments must carry 'ReportedInfo' or the API rejects the upload.
 * Derived from the folder rather than left to the caller, so a consumer cannot
 * omit it by accident — which is exactly how job uploads broke when this panel
 * was generalised beyond services.
 */
export const FOLDER_UPLOAD_CATEGORY: Partial<Record<Folders, string>> = {
  [Folders.ServiceAttachments]: 'ReportedInfo',
};

export type FilterType = 'all' | 'images' | 'pdfs' | 'documents' | 'other';

export const FILTERS: { key: FilterType; label: string }[] = [
  { key: 'all', label: 'All' },
  { key: 'images', label: 'Images' },
  { key: 'pdfs', label: 'PDFs' },
  { key: 'documents', label: 'Documents' },
  { key: 'other', label: 'Other' },
];

export const classifyFile = (mime: string): FilterType => {
  if (!mime) return 'other';
  if (mime.startsWith('image/')) return 'images';
  if (mime === 'application/pdf') return 'pdfs';
  if (
    mime.includes('spreadsheet') ||
    mime.includes('document') ||
    mime.includes('ms-excel') ||
    mime.includes('csv') ||
    mime.includes('text/')
  )
    return 'documents';
  return 'other';
};
